import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, ArrowLeft, Send, Check } from "lucide-react";
import { API } from "../lib/api";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <section className="min-h-[80vh] bg-cream-100 py-16 px-5">
      <div className="max-w-md mx-auto">
        <Link to="/login" className="text-sm text-navy-700/60 hover:text-coral-300 inline-flex items-center gap-1 mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="bg-white rounded-2xl soft-shadow p-8" data-testid="forgot-password-card">
          <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">Reset password</p>
          <h1 className="font-serif text-navy-700 text-3xl mt-2">Forgot your <span className="italic">password?</span></h1>
          <p className="text-navy-700/60 text-sm mt-2">Enter the email on your account — we&apos;ll send a secure reset link.</p>

          {sent ? (
            <div data-testid="forgot-password-sent" className="mt-6 bg-emerald-50 border border-emerald-200 rounded-xl p-4 flex items-start gap-3">
              <Check className="w-5 h-5 text-emerald-600 mt-0.5 shrink-0" />
              <div>
                <div className="font-semibold text-emerald-800">Check your inbox</div>
                <p className="text-sm text-emerald-800/80 mt-1">If an account exists for <b>{email}</b>, a reset link is on the way. The link expires in 60 minutes. Check your spam folder if you don&apos;t see it in a couple minutes.</p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-navy-700">Email</label>
                <div className="relative mt-2">
                  <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-navy-700/40" />
                  <input
                    required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-password-email-input"
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-cream-200 focus:outline-none focus:border-coral-300"
                    placeholder="you@email.com"
                  />
                </div>
              </div>
              {err && <div data-testid="forgot-password-error" className="text-sm text-red-600 bg-red-50 rounded-md px-3 py-2">{err}</div>}
              <button disabled={busy} type="submit" data-testid="forgot-password-submit-btn"
                className="w-full bg-coral-300 text-white py-3 rounded-full font-semibold hover:bg-coral-400 disabled:opacity-60 inline-flex items-center justify-center gap-2">
                {busy ? "Sending..." : <><Send className="w-4 h-4" /> Send reset link</>}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordPage;
